import React from "react";
import { Box, Stack, Typography } from "convertupleads-theme";
import ChipFilledColor from "./ChipFilledColor";
import ChipFilledDisabled from "./ChipFilledDisabled";
import ChipFilledSize from "./ChipFilledSize";
import ChipOutlinedColor from "./ChipOutlinedColor";
import ChipOutlinedSize from "./ChipOutlinedSize";
import ChipOutlinedDisabled from "./ChipOutlinedDisabled";
import ChipTonalSize from "./ChipTonalSize";
import ChipTonalColor from "./ChipTonalColor";
import ChipTonalDisabled from "./ChipTonalDisabled";
import BasicChipDemo from "./BasicChipDemo";

const BasicChip = () => {
  return (
    <div>
      <Stack spacing={2} p={3}>
        <Box>
          <Typography variant={"h6"} color={"text.primary"}>
            Basic Chip
          </Typography>
          <Typography variant={"body2"} color={"text.primary"}>
            The Chip component supports outlined and filled styling.
          </Typography>
        </Box>
        <Box sx={{ width: "80%", alignSelf: "center" }}>
          <BasicChipDemo />

          <ChipFilledSize />
          <ChipFilledColor />
          <ChipFilledDisabled />

          <ChipOutlinedSize />
          <ChipOutlinedColor />
          <ChipOutlinedDisabled />

          <ChipTonalSize />
          <ChipTonalColor />
          <ChipTonalDisabled />
        </Box>
      </Stack>
    </div>
  );
};

export default BasicChip;
